export interface TagRestrictions {
    requiredChildren: string[];
    nestedRequiredChildren?: Record<string, string[]>; // TODO: remove requiredChildren
    requiredAttributes: string[];
}

export const tagRestrictions: Record<string, TagRestrictions> = {
    zyquestiontf: {
        requiredChildren: ['zyq'],
        nestedRequiredChildren: {
            zyq: ['zyqtext', 'zyqexpl'],
        },
        requiredAttributes: ['id', 'caption'],
    },
    zyqsettf: {
        requiredChildren: ['zyq'], // or zyVersion wrapping zyQ
        nestedRequiredChildren: {
            zyq: ['zyqtext', 'zyqexpl'],
        },
        requiredAttributes: ['id', 'caption'],
    },
    zyq: {
        requiredChildren: ['zyqtext', 'zyqexpl'],
        nestedRequiredChildren: {},
        requiredAttributes: [],
    },
    zyquestionshortanswer: {
        requiredChildren: ['zyq'], // or zyVersion wrapping zyQ
        nestedRequiredChildren: {
            zyq: ['zyqtext', 'zyqexpl', 'zyqans', 'zyqhint', 'zyqtextaroundans'],
            zyqtextaroundans: ['zyqansbox'],
        },
        requiredAttributes: ['id', 'caption'],
    },
    zyqsetshortanswer: {
        requiredChildren: ['zyq'], // or zyVersion wrapping zyQ
        nestedRequiredChildren: {
            zyq: ['zyqtext', 'zyqexpl', 'zyqans', 'zyqhint'],
            zyqtextaroundans: ['zyqansbox'],
        },
        requiredAttributes: ['id', 'caption'],
    },
    zyquestionsurvey: {
        requiredChildren: ['zyq'], // or zyVersion wrapping zyQ
        nestedRequiredChildren: {
            zyq: ['zyqtext', 'zyqexpl'],
            zyqtextaroundans: ['zyqansbox'],
        },
        requiredAttributes: ['id', 'caption'],
    },
    zyqsetsurvey: {
        requiredChildren: ['zyq'], // or zyVersion wrapping zyQ
        nestedRequiredChildren: {
            zyq: ['zyqtext', 'zyqexpl'],
            zyqtextaroundans: ['zyqansbox'],
        },
        requiredAttributes: ['id', 'caption'],
    },
    zyquestionmatch: {
        requiredChildren: [], // Pattern-based requirement (at least one pair)
        nestedRequiredChildren: {
            zyqmatchright: ['zyqexpl'], // Allows zyQExpl within zyQMatchRight
        },
        requiredAttributes: ['id', 'caption'],
    },
    zyqsetmatch: {
        requiredChildren: [], // Pattern-based requirement (at least one pair)
        nestedRequiredChildren: {
            zyqmatchright: ['zyqexpl'], // Allows zyQExpl within zyQMatchRight
        },
        requiredAttributes: ['id', 'caption'],
    },
    zyquestionmultiplechoice: {
        requiredChildren: ['zyq'], // or zyVersion wrapping zyQ
        nestedRequiredChildren: {
            zyq: ['zyqtext'], // First child must be zyQText
            zyqchoice: ['zyqans', 'zyqexpl'], // zyQChoice requires zyQAns and/or zyQExpl
        },
        requiredAttributes: ['id', 'caption'],
    },
    zyqsetmultiplechoice: {
        requiredChildren: ['zyq'], // or zyVersion wrapping zyQ
        nestedRequiredChildren: {
            zyq: ['zyqtext'], // First child must be zyQText
            zyqchoice: ['zyqans', 'zyqexpl'], // zyQChoice requires zyQAns and/or zyQExpl
        },
        requiredAttributes: ['id', 'caption'],
    },
    zyquestiondetectanswer: {
        requiredChildren: ['zyq'], // or zyVersion wrapping zyQ
        nestedRequiredChildren: {
            zyqoption: ['zyqtext', 'zyqexpl'], // Must have exactly 2 children: zyQText, zyQExpl
        },
        requiredAttributes: ['id', 'caption'],
    },
    zyqsetdetectanswer: {
        requiredChildren: ['zyq'], // or zyVersion wrapping zyQ
        nestedRequiredChildren: {
            zyqoption: ['zyqtext', 'zyqexpl'], // Must have exactly 2 children: zyQText, zyQExpl
        },
        requiredAttributes: ['id', 'caption'],
    },
    zyhomeworkproblem: {
        requiredChildren: ['zyinstructions', 'zytestvectors', 'zysolution'],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption', 'language'],
    },
    zyexercise: {
        requiredChildren: ['zyproblem'], // At least one zyProblem required
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption'],
    },
    zyblockquote: {
        requiredChildren: [], // At least one child required (expects zyQuote)
        nestedRequiredChildren: {},
        requiredAttributes: [],
    },
    zytool: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption', 'name'],
    },
    zyde: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption'],
    },
    zystudio: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption'],
    },
    zymathworkslearningtool: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption', 'height', 'width'],
    },
    zyanimator: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption'],
    },
    zyfigure: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption'],
    },
    zyenum: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption', 'type'],
    },
    zygdocdrawing: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id'],
    },
    zygdocimage: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id'],
    },
    zycommonerror: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id'],
    },
    zygoodpractice: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id'],
    },
    zytry: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption'],
    },
    zytable: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption'],
    },
    zyyoutubevideo: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption', 'link'],
    },
    zyfootnote: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id'],
    },
    zyimagelink: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['file', 'title'],
    },
    zyexample: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption'],
    },
    zylink: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['link'],
    },
    zyversion: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['version'],
    },
    zyinlineimage: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id'],
    },
    zyquestioncustom: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption'],
    },
    zygooru: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['gooruOid'],
    },
    zyhtml: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id'],
    },
    zyaside: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'name', 'type'],
    },
    //###########################################################
    // DEPRECATED TAGS - Listed for reference only
    //###########################################################
    zyhypeanimation: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption', 'file', 'height', 'width'],
    },
    zypytutor: {
        requiredChildren: ['zypytutorcode'],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption'],
    },
    zyconstruct: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'caption'],
    },
    zyimage: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['id', 'file', 'height', 'width', 'title'],
    },
    zyfile: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: ['file', 'title', 'id'],
    },
    zycaution: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: [],
    },
    zyterm: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: [],
    },
    zycaption: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: [],
    },
    zyblock: {
        requiredChildren: [],
        nestedRequiredChildren: {},
        requiredAttributes: [],
    },
};

export function getTagRestrictions(tagName: string): TagRestrictions | undefined {
    const normalized = tagName.toLowerCase();
    return tagRestrictions[normalized];
}

export function isRequiredChild(parentTag: string, childTag: string, context?: string): boolean {
    const restrictions = getTagRestrictions(parentTag);
    if (!restrictions) return false;

    const normalizedChild = childTag.toLowerCase();

    if (context && restrictions.nestedRequiredChildren) {
        const contextKey = context.toLowerCase();
        const nestedRequired = restrictions.nestedRequiredChildren[contextKey];
        if (nestedRequired && nestedRequired.includes(normalizedChild)) {
            return true;
        }
    }

    return restrictions.requiredChildren.includes(normalizedChild);
}

export function isRequiredAttribute(tagName: string, attribute: string): boolean {
    const restrictions = getTagRestrictions(tagName);
    if (!restrictions) return false;

    const normalizedAttr = attribute.toLowerCase();
    return restrictions.requiredAttributes.includes(normalizedAttr);
}

/**
 * Check if zyQOption requires 'correct' attribute
 * This is a special case for zyQuestionDetectAnswer / zyQSetDetectAnswer
 * @param parentTag - Parent tag name
 * @param childTag - Should be "zyqoption"
 * @returns true if correct attribute is required
 */
export function requiresCorrectAttribute(parentTag: string, childTag: string): boolean {
    const normalizedParent = parentTag.toLowerCase();
    const normalizedChild = childTag.toLowerCase();

    return (normalizedParent === 'zyquestiondetectanswer' || normalizedParent === 'zyqsetdetectanswer') && normalizedChild === 'zyqoption';
}
